import { Form } from 'antd'
import Button from 'components/Button/index'
import InfoCards from 'components/InfoCards'
import PlusIcon from 'components/icons/PlusIcon'
import AddUserDrawer from 'modules/Users/Partials/AddUserDrawer'
import UsersFilter from 'modules/Users/Partials/UsersFilter'
import UsersTable from 'modules/Users/Partials/UsersTable'
import { getCardData } from 'modules/Users/Partials/constant'
import {
  CardRow,
  PaddedDiv,
  SectionWrapper,
  TopHeader,
  TopHeading,
} from 'modules/Users/Style/style'
import React, { useEffect, useRef, useState } from 'react'
import { permittedEventCruds } from '../../utils/permissionsValidation'

const Users = ({
  getUserMetrics,
  getUserList,
  userMetrics,
  userList,
  getUserRoles,
  userRole,
  createUser,
  updateUser,
  getSingleUser,
  singleUserData,
  updateUserStatus,
  deleteUser,
  setSingleUser,
  permissions,
  getListOfCountries,
  getNotificationCatalogues,
  notificationCatalogues,
  sendNotificationEmail,
}) => {
  const [form] = Form.useForm()
  const object = useRef()
  const [userData, setUserData] = useState(getCardData || [])
  const [state, setState] = useState('all')
  const [addUserDrawer, setAddUserDrawer] = useState(false)

  const [pageNum, setPageNum] = useState(1)
  const [searchValue, setSearchValue] = useState('')
  const [sortBy, setSortBy] = useState('')
  const [loading, setLoading] = useState(false)

  const [userRoleValue, setUserRoleValue] = useState('')
  const [userStatus, setUserStatus] = useState('')

  const [userId, setUserId] = useState('')
  const [updateLoading, setUpdateLoading] = useState(false)
  const [eventId, setEventId] = useState('')
  const [editTemplate, setEditTemplate] = useState(null)
  const [inActiveTemplate, setInActiveTemplate] = useState(null)
  const [activeTemplate, setActiveTemplate] = useState(null)

  const onCardClick = key => {
    setState(key)
    setUserStatus(key === 'all' ? '' : key)
    setUserRoleValue('')
    setPageNum(1)
  }

  const getUserData = async () => {
    setLoading(true)
    const response = await getUserList({
      searchValue,
      sortBy,
      userRoleValue,
      userStatus,
      pageNum,
    })
    setLoading(response)
  }
  const getUserDataFilter = async () => {
    setLoading(true)
    let pageNum = 1
    setPageNum(1)
    const response = await getUserList({
      searchValue,
      sortBy,
      userRoleValue,
      userStatus,
      pageNum,
    })
    setLoading(response)
  }
  const getSingleUserInfo = async userId => {
    setUpdateLoading(true)
    await getSingleUser({ userId })
    setUpdateLoading(false)
  }

  const onAddUser = id => {
    setEventId(id)
    setAddUserDrawer(true)
    setSingleUser({})
    form.resetFields()
  }

  useEffect(() => {
    getUserRoles()
  }, [])

  useEffect(() => {
    getUserMetrics()
  }, [userList])

  useEffect(() => {
    getUserData()
  }, [pageNum, sortBy, state])
  useEffect(() => {
    setPageNum(1)
    getUserData()
  }, [searchValue])

  useEffect(() => {
    let response = getCardData(userMetrics)
    setUserData(response)
  }, [userMetrics])

  const cruds = permittedEventCruds(permissions, 'USERS')?.map(permission =>
    permission?.events?.eventName?.toUpperCase()
  )

  const permittedEvents = permittedEventCruds(permissions, 'USERS')
  const addNewUser =
    permittedEvents?.find(item => item.events?.eventName === 'ADD USER')
      ?.events || ''

  const Edit =
    permittedEvents?.find(item => item.events?.eventName === 'EDIT')?.events ||
    ''
  const InActive =
    permittedEvents?.find(item => item.events?.eventName === 'Active/inactive')
      ?.events || ''
  const Active =
    permittedEvents?.find(item => item.events?.eventName === 'Active/inactive')
      ?.events || ''

  useEffect(() => {
    ;(async () => {
      if (Edit?.id) {
        let responce = await getNotificationCatalogues(Edit?.id)
        const filteredArray = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName ===
              'User Role updation' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'E-Mail'
        )

        if (filteredArray?.length > 0) {
          setEditTemplate(filteredArray[0].eventNotificationTemplate)
        }
      }
    })()

    return () => {}
  }, [Edit])

  useEffect(() => {
    ;(async () => {
      if (InActive?.id) {
        let responce = await getNotificationCatalogues(InActive?.id)
        const filteredArray = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName === 'User InActive' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'E-Mail'
        )

        if (filteredArray?.length > 0) {
          setInActiveTemplate(filteredArray[0].eventNotificationTemplate)
        }
      }
    })()

    return () => {}
  }, [InActive])
  useEffect(() => {
    ;(async () => {
      if (Active?.id) {
        let responce = await getNotificationCatalogues(Active?.id)
        const filteredArray = responce?.CatalogueData?.filter(
          item =>
            item.eventNotificationTemplate &&
            item.eventNotificationTemplate.templateName === 'User Activation' &&
            item.eventNotificationTemplate.eventNotificationType &&
            item.eventNotificationTemplate.eventNotificationType.name ===
              'E-Mail'
        )

        if (filteredArray?.length > 0) {
          setActiveTemplate(filteredArray[0].eventNotificationTemplate)
        }
      }
    })()

    return () => {}
  }, [Active])
  const ScrollRef = () => {
    object.current.scrollIntoView({ behavior: 'smooth' })
  }
  return (
    <>
      <SectionWrapper column>
        <div ref={object}></div>
        <PaddedDiv column>
          <TopHeader row spaceBetween alignCenter>
            <TopHeading flexStart>Users</TopHeading>
            {addNewUser && (
              <Button.Primary
                height={'38px'}
                text={'Add User'}
                icon={<PlusIcon />}
                onClick={() => onAddUser(addNewUser?.id)}
              />
            )}
          </TopHeader>

          <CardRow>
            {userData?.map(card => (
              <InfoCards
                key={card?.key}
                width={'25%'}
                height="130px"
                icon={card?.icon}
                text={card?.text}
                value={card?.value}
                state={card?.state}
                current={state}
                onClick={() => onCardClick(card?.state)}
              />
            ))}
          </CardRow>
        </PaddedDiv>

        <UsersFilter
          getUserDataFilter={getUserDataFilter}
          searchValue={searchValue}
          setSearchValue={setSearchValue}
          userRole={userRole}
          userRoleValue={userRoleValue}
          setUserRoleValue={setUserRoleValue}
          userStatus={userStatus}
          setUserStatus={setUserStatus}
          getUserData={getUserData}
          setState={setState}
          userList={userList}
        />

        <UsersTable
          cruds={cruds}
          userList={userList}
          userRole={userRole}
          setSortBy={setSortBy}
          loading={loading}
          getSingleUserInfo={getSingleUserInfo}
          singleUserData={singleUserData}
          setAddUserDrawer={setAddUserDrawer}
          setUserId={setUserId}
          updateUserStatus={updateUserStatus}
          deleteUser={deleteUser}
          setPageNum={setPageNum}
          getUserData={getUserData}
          pageNum={pageNum}
          updateLoading={updateLoading}
          inActiveTemplate={inActiveTemplate}
          activeTemplate={activeTemplate}
          sendNotificationEmail={sendNotificationEmail}
          ScrollRef={ScrollRef}
        />
      </SectionWrapper>

      <AddUserDrawer
        addUserDrawer={addUserDrawer}
        setAddUserDrawer={setAddUserDrawer}
        userRole={userRole}
        createUser={createUser}
        updateUser={updateUser}
        singleUserData={singleUserData}
        userId={userId}
        getUserData={getUserData}
        updateLoading={updateLoading}
        form={form}
        getListOfCountries={getListOfCountries}
        eventId={addNewUser?.id}
        setEventId={setEventId}
        eventId1={eventId}
        editTemplate={editTemplate}
        sendNotificationEmail={sendNotificationEmail}
      />
    </>
  )
}

export default Users
